import React, { useState, useEffect } from 'react';
import { Wrench } from 'lucide-react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ConstructionPage = () => {
  return (
    <div className="min-h-screen bg-gray-950 flex flex-col items-center justify-center p-6" data-testid="construction-page">
      <div className="text-center max-w-lg">
        <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-orange-500/10 mb-8">
          <Wrench className="w-12 h-12 text-orange-500 animate-pulse" />
        </div>
        <h1 className="text-5xl font-black text-white tracking-tight mb-2">
          POSTER<span className="text-orange-500">FIRE</span>
        </h1>
        <div className="w-16 h-1 bg-orange-500 mx-auto my-6" />
        <h2 className="text-2xl font-bold text-white mb-4">Under Construction</h2>
        <p className="text-gray-400 text-lg leading-relaxed mb-8">
          We're building something amazing. Our poster collection is getting a major upgrade — check back soon!
        </p>
        <div className="flex items-center justify-center gap-2 text-sm text-gray-600">
          <div className="w-2 h-2 rounded-full bg-orange-500 animate-pulse" />
          <span>Work in progress</span>
        </div>
      </div>
      <Link
        to="/aaa"
        className="fixed bottom-4 left-4 text-gray-700 hover:text-gray-500 transition-colors"
        data-testid="construction-admin-login"
        style={{ fontSize: '11px', letterSpacing: '1px', fontFamily: 'monospace' }}
      >
        AA
      </Link>
    </div>
  );
};

export const useConstructionMode = () => {
  const [isConstruction, setIsConstruction] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    axios.get(`${API}/site-status`)
      .then(r => { setIsConstruction(r.data.construction_mode); setChecked(true); })
      .catch(() => setChecked(true));
  }, []);

  return { isConstruction, checked };
};

export default ConstructionPage;
